<template>
	<div class="about">
		<img class="wow fadeIn" style="width: 100%;" src="../../assets/aboutBg.jpg" />
		<div class="contentinfo  mainArea">
			<h1>上海橙猩数字娱乐科技有限公司</h1>
			<p class="a"> &nbsp;&nbsp;&nbsp;&nbsp;上海橙猩数字娱乐科技有限公司成立于2022年，深耕娱乐新空间运营，并在上下游布局内容投资和数字营销。橙猩数娱运用优质内容和创新科技重塑娱乐消费体验，致力于成为全球领先的场景娱乐（LBE）投资、发行和运营平台。</p>
			<p> &nbsp;&nbsp;&nbsp;&nbsp;橙猩数娱由天下票仓（上海）网络科技有限公司创立，并在发展过程中不断引入多元化、市场化战略合作伙伴。天下票仓成立于2013年，是国内较早运用互联网技术为文化产业赋能的“娱乐+科技”型企业。</p>
		</div>		
	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'Home',
		data() {
			return {
				timelineItems: [{
					date: "2022",
					title: "转型升级",
					description: "推出新厂牌“橙猩”，启动精品内容、娱乐新空间和数字营销“三轮驱动”战略。",
				},{
					date: "2019",
					title: "完成混改",
					description: "公司引进多元投资者，成为兼具国企股东背景和灵活市场机制的混合所有制企业。",
				},{
					date: "2016",
					title: "股东上市",
					description: "公司股东上海电影股份有限公司在A股主板上市，公司发展驶入快车道。",
				},{
					date: "2013",
					title: "公司成立",
					description: "为电影发行和放映提供互联网技术和营销服务，是国内第一代运用互联网技术<br>为文化产业赋能的“娱乐+科技”型企业。",
				}, ]
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(isM){
				this.$router.push({ path: '/mobile/about'});
			}
		},
		mounted() {
			this.$nextTick(() => {
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		}
	}
</script>
<style lang="less" scoped>
	.fazhan {
		text-align: left;
		margin-top: 100px;
		padding-top:100px;
		min-height: 1200px;
		overflow: hidden;
		position: relative;
		background: url('../../assets/fazhan.jpg') no-repeat center top;
		background-size: 100vw auto;		
		.title{
			font-size: 2rem;
			color: #FB5400;
			margin-bottom: 100px;
			font-weight: bold;
		}
	}
	.timeline{
		position: relative;
		padding-top: 50px;
		padding-bottom: 50px;
	}
	.timeline::before {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		left: 135px;
		/* 左对齐位置 */
		width: 1px;
		background: #FB5400;
	}

	/* 时间轴项 */
	.timeline-item {
		display: flex;
		align-items: center;
		margin-bottom: 80px;
		position: relative;
		transition: all 0.8s ease;
	}



	/* 节点 */
	.timeline-node {
		position: absolute;
		top: 50%;
		left: 130px;
		/* 与轴线对齐 */
		width: 12px;
		height: 12px;
		background: #FB5400;
		border-radius: 50%;
		z-index: 2;
	}
	.timeline-content{
		margin-left: 50px;
	}
	/* 时间样式 */
	.timeline-date {
		width: 130px;
		flex-shrink: 0;
		color: #FB5400;
		font-weight: bold;
		font-size: 40px;
	}

	.timeline-period {
		color: #7f8c8d;
		font-size: 1rem;
	}

	/* 内容样式 */
	.timeline-title {
		font-weight: bold;
		font-size: 1.8rem;
		margin-bottom: 15px;
		color: #2c3e50;
		display: flex;
		align-items: center;
	}

	.timeline-desc {
		color: #34495e;
		line-height: 1.7;
		font-size: 1.2rem;
	}
	
	.contentinfo {
		position: relative;
		border-radius: 5px;
		background: #fff;
		margin-top: -100px;
		padding: 80px;
		z-index: 2;

		h1 {
			padding-left: 30px;
			color: #333 !important;
			font-size: 50px;
			line-height: 80px;

			text-align: left;
		}

		p {
			color: #555 !important;
			line-height: 50px;
			font-size: 20px;
			padding-bottom: 30px;
			text-align: left;
			&.a{
				padding-bottom: 30px;
				padding-top: 30px;
			}
		}

	}
	@media (max-width:1440px) {
		.contentinfo {
			padding: 30px;
			h1 {
				font-size: 30px;
			}
		
			p {
				font-size: 14px;
				padding-bottom: 20px;
				&.a{
					padding-bottom: 10px;
					padding-top:10px;
				}
			}
			}
		.fazhan {
			padding-top:50px;
			min-height: 650px;
			background-size: 100vw 650px;		
			.title{
				font-size: 2rem;
				color: #FB5400;
				margin-bottom: 50px;
				font-weight: bold;
			}
		}
		.timeline{
			position: relative;
			padding-top: 30px;
			padding-bottom: 30px;
		}
		.timeline-item {
			margin-bottom: 50px;
		}
		.timeline-date {
			font-size: 30px;
		}
		/* 内容样式 */
		.timeline-title {
			font-size: 1rem;
		}
		.timeline-desc {
			font-size: 0.5rem;
		}
	}
	@media (max-width:800px) {
		.contentinfo {
			margin-top: -50px;
			padding: 20px;
			
			h1 {
				font-size: 20px;
			}		
			p {
				font-size: 14px;
				line-height: 30px;
				padding-bottom: 10px;
				&.a{
					padding-bottom: 10px;
					padding-top: 10px;					
				}
			}
		}
		.timeline-date{
			width: 60px;
		}
		.timeline-node{
			left: 85px;
		}
		.timeline::before {
			left: 90px;
		}
		
	}
</style>